/* eslint-disable no-unused-expressions */
/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useMemo, useEffect, useState, useRef, useCallback } from "react";
import VoiceService from "./VH-Myra-FrontEnd";
import styles from "./MyraAgent.module.css";
import MyraInteraction from "../self-assesment2/MyraInteractionController";
import { MyraFab, ChatPanel, VoicePanel } from "../self-assesment2/SelfAssessmentUi";
import { generatePayloadForScreen } from "../self-assesment2/generatePayloadForScreen";

/** ---------- Presentational bit (UI-only refresh) ---------- */
function VoiceAgent({ isListening, isAgentSpeaking, isVisible, onMicClick, isVoiceActive, connectionStatus, isFlowStarted, mode, isFabExpanded, isBubbleVisible, isChatOpen, isVoiceOpen, chatMessages, introARState, onFabTap, onPickChat, onPickVoice, onDismissBubble, onCloseChat, onCloseVoice, onSendChatMessage, onSwitchMode, isChatLoading, onMicRequest }) {
  const [debugText, setDebugText] = React.useState("");
  const [qaSilencePhase, setQaSilencePhase] = React.useState("listening");
  let isGsaFlow = VoiceService._currentFlow === "flow_gsa";

  let isHelfFlow = VoiceService._currentFlow === "flow_exercise" || window.currentFlow === "flow_exercise";
  React.useEffect(() => {
    if (isAgentSpeaking && debugText) {
      if (document.getElementById("debugVoice")) {
        document.getElementById("debugVoice").innerHTML = "";
      }
      setDebugText("");
    }
  }, [isAgentSpeaking, debugText]);

  // Reset thinking state whenever the agent starts speaking
  React.useEffect(() => {
    if (isAgentSpeaking && debugText === "Processing your question…") {
      if (document.getElementById("debugVoice")) {
        document.getElementById("debugVoice").innerHTML = "";
      }
      setDebugText("");
    }
  }, [isAgentSpeaking]);

  React.useEffect(() => {
    if (isAgentSpeaking) return;
    if (!debugText) return;

    const interval = setInterval(() => {
      const silenceMs = VoiceService.getSilenceDurationMs?.() || 0;
      if (silenceMs < 2000) {
        setQaSilencePhase("listening");
      } else if (silenceMs < 3000) {
        setQaSilencePhase("still");
      } else {
        setQaSilencePhase("thinking");
      }
      if (connectionStatus === "Reset_Status") {
        setQaSilencePhase("listening");
      }
    }, 200);

    return () => clearInterval(interval);
  }, [debugText, isAgentSpeaking]);

  React.useEffect(() => {
    if (isAgentSpeaking) {
      setQaSilencePhase("listening");
    }
  }, [isAgentSpeaking]);

  React.useEffect(() => {
    const el = document.getElementById("debugVoice");
    if (!el) return;

    const observer = new MutationObserver(() => {
      setDebugText(el.innerHTML.trim());
    });

    observer.observe(el, { childList: true, subtree: true, characterData: true });

    return () => observer.disconnect();
  }, []);

  if (!window.doMyTest || !isVisible) {
    return <div />;
  }

  // Default = Listening (red mic), Speaking = green mic
  const micClasses = [styles.micButton, isHelfFlow && styles.helpMicButton, !isAgentSpeaking ? styles.micButtonListening : ""].filter(Boolean).join(" ");

  // Show overlay whenever voice is active
  // Show overlay only when voice is active OR connection issues (but not when not initialized)
  const showOverlay = isVoiceActive || (connectionStatus !== "not_initialized" && (connectionStatus === "disconnected" || connectionStatus === "reconnecting" || connectionStatus === "Preparing_Response" || connectionStatus === "Processing_Question" || connectionStatus === "Reset_Status"));
  const QNA_FLOWS = ["flow_plan_v2", "flow_landing_page", "flow_post_session_qa", "flow_gsa"];
  const isQnAFlow = QNA_FLOWS.includes(window.currentFlow);

  console.log("Connection status is : ", connectionStatus);
  console.log("Current flow is : ", window.currentFlow);

  // Text to show in status pill
  let statusText = "";
  const isInitialConnection = !isVisible && !isFlowStarted;
  if (connectionStatus === "not_initialized") {
    statusText = "";
  } else if (connectionStatus === "disconnected") {
    statusText = isInitialConnection ? "Connecting..." : "Connection lost, trying to reconnect…";
  } else if (connectionStatus === "reconnecting") {
    statusText = "Connecting...";
  } else if (isAgentSpeaking) {
    // SPEAKING takes highest priority when agent is actually speaking
    statusText = "Speaking...";
  } else if (connectionStatus === "Processing_Question") {
    // Show preparing only when NOT speaking
    statusText = "Processing your question...";
  } else if (connectionStatus === "Forced_Status" && window.forcedStatusMyra) {
    // Show preparing only when NOT speaking
    statusText = window.forcedStatusMyra;
  } else if (connectionStatus === "Preparing_Response") {
    // Show preparing only when NOT speaking
    statusText = "Preparing our response…";
  } else if (debugText && isListening) {
    if (qaSilencePhase === "listening") {
      statusText = `Listening… "${debugText}"`;
    } else if (qaSilencePhase === "still") {
      statusText = `Still listening… "${debugText}"`;
    } else if (qaSilencePhase === "thinking") {
      statusText = `Thinking… "${debugText}"`;
    }
  } else if (debugText) {
    statusText = '"' + debugText + '"';
  } else {
    statusText = isQnAFlow ? "Ask me anything..." : "Listening...";
  }

  if (isHelfFlow && statusText === "Listening...") {
    statusText = "";
  }

  if (!window.lastSaidText && !!debugText && window.callbackUserStartedSpeaking) {
    window.callbackUserStartedSpeaking();
  }

  window.lastSaidText = debugText;

  const handleFabOrMicClick = () => {
    onFabTap();
  };
  const showLegacyMic = !mode || mode === "voice";
  const shouldShowFab = !mode || mode === "chat" || mode === "button";

  return (
    <>
      {<MyraFab onFabTap={onFabTap} onPickChat={onPickChat} onPickVoice={onPickVoice} isFabExpanded={isFabExpanded} isBubbleVisible={isBubbleVisible} onDismissBubble={onDismissBubble} statusText={statusText} />}

      {/* Chat Panel - ONLY render when open */}
      {isChatOpen && <ChatPanel messages={chatMessages} onClose={onCloseChat} onSend={onSendChatMessage} onSwitchVoice={() => onSwitchMode("voice")} onSwitchButton={() => onSwitchMode("button")} isChatLoading={isChatLoading} />}

      {/* Voice Panel - ONLY render when open */}
      {isVoiceOpen && <VoicePanel isAgentSpeaking={isAgentSpeaking} onClose={onCloseVoice} onSwitchChat={() => onSwitchMode("chat")} onSwitchButton={() => onSwitchMode("button")} onMicRequest={onMicRequest} statusText={statusText} />}
    </>
  );
}

/** ---------- Hook that manages VoiceService ---------- */
function useVoiceAgent({ flow = true, initialized = false, flowName = "", isManuallyDisabled = false, isManuallyDisabledRef, isEnabled, announcement = "" } = {}) {
  const [isAgentSpeaking, setIsAgentSpeaking] = useState(false);
  const [isListening, setIsListening] = useState(false);
  const [currentFlow, setCurrentFlow] = useState(flowName || "");
  const [connectionStatus, setConnectionStatus] = useState("");

  useEffect(() => {
    const checkConnectionStatus = () => {
      if (VoiceService.getConnectionStatus) {
        const status = VoiceService.getConnectionStatus();
        setConnectionStatus(status);

        // NEW: If disconnected and we should be connected, try to reconnect
        if (status === "disconnected" && !isManuallyDisabledRef.current && isEnabled && navigator.onLine && !VoiceService._intentionalClose) {
          console.log("[AGENT] Detected disconnected state, attempting to reconnect...");

          // Wait a moment before attempting to reconnect
          setTimeout(() => {
            if (VoiceService.forceReconnect) {
              VoiceService.forceReconnect();
            } else {
              // Fallback to initialize if forceReconnect doesn't exist
              VoiceService.initialize();
            }
          }, 2000);
        }
      }
    };

    // Check status more frequently when disconnected
    const checkInterval = connectionStatus === "disconnected" ? 2000 : 5000;
    const interval = setInterval(checkConnectionStatus, checkInterval);

    // Also check when connection events might occur
    const originalOnConnected = VoiceService._callbacks?.onConnected;
    VoiceService._callbacks.onConnected = () => {
      setConnectionStatus("connected");
      if (originalOnConnected) originalOnConnected();
    };

    window.forceStatusUpdate = () => {
      checkConnectionStatus();
    };

    return () => {
      clearInterval(interval);
      if (originalOnConnected) {
        VoiceService._callbacks.onConnected = originalOnConnected;
      }
    };
  }, [connectionStatus, isEnabled, isManuallyDisabledRef]);

  // store previous callbacks so we can restore on unmount
  const prevCallbacks = useRef({
    onAgentSpeechStart: undefined,
    onAgentSpeechEnd: undefined,
    onListeningStart: undefined,
    onListeningStop: undefined,
  });

  const wireCallbacks = useCallback(() => {
    const cb = VoiceService._callbacks || (VoiceService._callbacks = {});
    // keep originals
    prevCallbacks.current = {
      onAgentSpeechStart: cb.onAgentSpeechStart,
      onAgentSpeechEnd: cb.onAgentSpeechEnd,
      onListeningStart: cb.onListeningStart,
      onListeningStop: cb.onListeningStop,
    };

    cb.onAgentSpeechStart = () => {
      setIsAgentSpeaking(true);
    };

    cb.onAgentSpeechEnd = () => {
      setIsAgentSpeaking(false);
    };

    cb.onListeningStart = () => {
      setIsListening(true);
    };

    cb.onListeningStop = () => {
      setIsListening(false);
    };
  }, []);

  const initializeVoice = useCallback(() => {
    wireCallbacks();

    const userName = window.localStorage.getItem("self_name") || "";

    if (initialized) {
      VoiceService.initialize({
        onConnected: () => {
          console.log("Connected voice service...");
          if (flowName) VoiceService.startFlow(flowName, userName, announcement);
          console.log("[start by me 1]");
        },
      });
    } else if (flow && flowName) {
      VoiceService.startFlow(flowName, userName, announcement);
      console.log("[start by me 2]");
    }
  }, [flow, initialized, flowName, wireCallbacks, announcement]);

  const startFlow = useCallback(
    (name, announcement = "", callbackEndSay) => {
      // if (VoiceService._resourceManager && VoiceService._resourceManager.monitor?.isRunning) {
      //   VoiceService._resourceManager.stopMonitoring();
      // }
      // if (VoiceService._resourceManager) {
      //   const canvas = document.getElementById("pose-canvas") || document.getElementById("ar-canvas");
      //   if (canvas) {
      //     VoiceService._resourceManager.startMonitoring(canvas);
      //   }
      // }

      if (typeof announcement == "function" && !callbackEndSay) {
        callbackEndSay = announcement;
        announcement = "";
      }

      VoiceService.stopAllVoiceActivity();
      VoiceService._currentFlow = name;
      let flowToCheck = "flow_personalized";
      if (window.currentFlow === "flow_personalized" && (name === "flow_silent" || name === "flow_exercise")) {
        console.log("[FLOW GUARD] Prevented flow override:", name);
        return;
      }
      const userName = window.localStorage.getItem("self_name") || "";
      window.currentFlow = name;
      setCurrentFlow(name);
      // const screenName = FLOW_TO_SCREEN[name] || name;
      // MyraInteraction.onScreenEnter(screenName);
      if (isManuallyDisabledRef.current) {
        console.log("Voice agent is manually disabled, not starting flow:", name);
        return;
      }

      if (VoiceService._connected) {
        console.log("Start new flow", name);
        // VoiceService.forceStop();
        wireCallbacks();
        if (name) VoiceService.startFlow(name, userName, announcement);
        console.log("[start by me 3]");
        window.currentFlow = name;

        if (callbackEndSay) {
          setTimeout(() => {
            VoiceService._callbacks.onAgentSpeechEndCustom = () => {
              console.log("Called back");

              if (callbackEndSay) {
                callbackEndSay();
              }
              VoiceService._callbacks.onAgentSpeechEndCustom = () => {};
            };
          }, 3000);
        }
      } else {
        wireCallbacks();
        VoiceService.initialize({
          onConnected: () => {
            console.log("Connected voice service...", name);
            if (name) VoiceService.startFlow(name, userName, announcement);
            console.log("[start by me 4]");
            window.currentFlow = name;

            if (callbackEndSay) {
              setTimeout(() => {
                VoiceService._callbacks.onAgentSpeechEndCustom = () => {
                  console.log("Called back");

                  if (callbackEndSay) {
                    callbackEndSay();
                  }
                  VoiceService._callbacks.onAgentSpeechEndCustom = () => {};
                };
              }, 3000);
            }
          },
        });
      }
    },
    [wireCallbacks, isManuallyDisabledRef],
  );

  const sendPostQA = useCallback(
    (sendData) => {
      VoiceService.sendPostQA(sendData);
    },
    [wireCallbacks, isManuallyDisabledRef],
  );

  useEffect(() => {
    return () => {
      if (!VoiceService._callbacks) return;
      VoiceService._callbacks.onAgentSpeechStart = prevCallbacks.current.onAgentSpeechStart;
      VoiceService._callbacks.onAgentSpeechEnd = prevCallbacks.current.onAgentSpeechEnd;
      VoiceService._callbacks.onListeningStart = prevCallbacks.current.onListeningStart;
      VoiceService._callbacks.onListeningStop = prevCallbacks.current.onListeningStop;
    };
  }, []);

  return { isAgentSpeaking, isListening, initializeVoice, startFlow, sendPostQA, connectionStatus };
}

function MyraAgent(props) {
  const [isVisible, setIsVisible] = useState(false);
  const [isEnabled, setIsEnabled] = useState(false);
  const [isManuallyDisabled, setIsManuallyDisabled] = useState(false);
  const isManuallyDisabledRef = useRef(isManuallyDisabled);
  const [isFlowStarted, setIsFlowStarted] = useState(false);
  const [micPermissionState, setMicPermissionState] = useState({
    status: "unknown", // 'granted', 'denied', 'prompt', 'unknown'
    callbacks: null,
  });

  // ── Controller state ──
  const [mode, setMode] = useState(MyraInteraction.getMode());
  const [isFabExpanded, setIsFabExpanded] = useState(MyraInteraction.isFabExpanded());
  const [isBubbleVisible, setIsBubbleVisible] = useState(MyraInteraction.isBubbleVisible());
  const [isChatOpen, setIsChatOpen] = useState(MyraInteraction.isChatOpen());
  const [isVoiceOpen, setIsVoiceOpen] = useState(MyraInteraction.isVoiceOpen());
  const [chatMessages, setChatMessages] = useState(MyraInteraction.getChatMessages());
  const [isMicModalOpen, setIsMicModalOpen] = useState(MyraInteraction.isMicModalOpen());
  const [introARSelectedMode, setIntroARSelectedMode] = useState("voice");
  const [isChatLoading, setIsChatLoading] = useState(MyraInteraction.isChatLoading());

  useEffect(() => {
    isManuallyDisabledRef.current = isManuallyDisabled;
  }, [isManuallyDisabled]);

  const { isAgentSpeaking, isListening, initializeVoice, startFlow, sendPostQA, connectionStatus } = useVoiceAgent({
    flow: true,
    initialized: false,
    flowName: "",
    isManuallyDisabled,
    isManuallyDisabledRef,
    isEnabled,
    ...props,
  });

  // Subscribe to all controller events
  useEffect(() => {
    const unsubs = [
      MyraInteraction.on("modeChange", ({ mode }) => setMode(mode)),
      MyraInteraction.on("fabToggle", ({ expanded }) => setIsFabExpanded(expanded)),
      MyraInteraction.on("bubbleChange", ({ visible }) => setIsBubbleVisible(visible)),
      MyraInteraction.on("chatOpen", () => setIsChatOpen(true)),
      MyraInteraction.on("chatClose", () => setIsChatOpen(false)),
      MyraInteraction.on("voiceOpen", () => setIsVoiceOpen(true)),
      MyraInteraction.on("voiceClose", () => setIsVoiceOpen(false)),
      MyraInteraction.on("chatHistoryUpdate", ({ messages }) => setChatMessages([...messages])),
      MyraInteraction.on("micPermissionShow", () => setIsMicModalOpen(true)),
      MyraInteraction.on("micPermissionClose", () => setIsMicModalOpen(false)),
      MyraInteraction.on("micDenied", () => setIsMicModalOpen(false)),
      MyraInteraction.on("chatLoadingChange", ({ loading }) => setIsChatLoading(loading)),
      MyraInteraction.on("reset", () => {
        setMode(null);
        setIsFabExpanded(false);
        setIsBubbleVisible(true);
        setIsChatOpen(false);
        setIsVoiceOpen(false);
        setChatMessages([]);
        setIsMicModalOpen(false);
      }),
    ];
    return () => unsubs.forEach((fn) => fn());
  }, []);

  const [toggleMic, setToggleMic] = useState(false);
  const [isVoiceActive, setIsVoiceActive] = useState(false);
  const activeFlowRef = useRef("");
  useEffect(() => {
    setIsVoiceActive(isAgentSpeaking || isListening);
  }, [isAgentSpeaking, isListening]);

  const getCurrentMicState = async () => {
    if (typeof navigator !== "undefined" && navigator.permissions && navigator.permissions.query) {
      try {
        const status = await navigator.permissions.query({ name: "microphone" });
        return status.state; // 'granted' | 'denied' | 'prompt'
      } catch {
        return "prompt"; // fall back to our cached state
      }
    }
    return "prompt"; // Safari/older browsers
  };
  const requestMicrophonePermission = useCallback(async (options = {}) => {
    const { onGrant, onDeny, onError, silent = false } = options;

    // Store callbacks for this request
    const permissionCallbacks = { onGrant, onDeny, onError };

    try {
      // Check current permission state first
      let currentState = await getCurrentMicState();

      if (currentState === "granted") {
        // Already granted
        if (onGrant) onGrant();
        window.dispatchEvent(new CustomEvent("mic-permission-granted"));
        return true;
      }

      if (currentState === "denied") {
        // Previously denied - can't request again programmatically
        if (onDeny) onDeny("permanently_denied");
        window.dispatchEvent(new CustomEvent("mic-permission-denied"));
        return false;
      }

      // State is 'prompt' or unknown - request access
      const constraints = getAudioConstraints();
      const stream = await navigator.mediaDevices.getUserMedia(constraints);

      // Success! Clean up tracks
      stream.getTracks().forEach((track) => track.stop());

      // Update state
      setMicPermissionState({ status: "granted", callbacks: null });

      if (onGrant) onGrant();
      window.dispatchEvent(new CustomEvent("mic-permission-granted"));
      return true;
    } catch (error) {
      console.error("[Mic Permission] Request failed:", error);

      if (error.name === "NotAllowedError" || error.name === "PermissionDeniedError") {
        setMicPermissionState({ status: "denied", callbacks: null });
        if (onDeny) onDeny("user_denied");
        window.dispatchEvent(new CustomEvent("mic-permission-denied"));
      } else if (onError) {
        onError(error);
      }

      return false;
    }
  }, []);

  // Helper to get platform-specific constraints
  const getAudioConstraints = () => {
    const ua = navigator.userAgent;
    const isMobile = /Android|webOS|iPhone|iPad|iPod/i.test(ua);
    const isMacDesktop = /Macintosh|Mac OS X/.test(ua) && !isMobile;

    if (isMacDesktop) {
      return { audio: { deviceId: "default" } };
    } else if (isMobile) {
      return { audio: true };
    } else {
      return { audio: { deviceId: "default" } };
    }
  };

  // eslint-disable-next-line
  const handleMicClick = async (silent = false, forceStarting = false, manualClick = false, ignoreReturn = false, ignoreMic = false) => {
    // ignoreReturn is added because from testintro screen we can ignore the selection and start the flow anyway

    const flowToStart = VoiceService._currentFlow || window.currentFlow;
    const currentMode = MyraInteraction.getMode();
    if (currentMode === "button") {
      MyraInteraction.onFabTap();
      if (!ignoreReturn) return;
    }
    if (currentMode === "chat") {
      MyraInteraction.openChat();
      if (!ignoreReturn) return;
    }
    // let currentScreen = MyraInteraction.getCurrentScreen();
    // const introARState = MyraInteraction.getIntroARState();

    // const isIntroARWithModeSelected = currentScreen === "intro_ar" && !introARState.showModeCard;

    // if (currentMode === "voice" || currentMode === null) {
    const userName = window.localStorage.getItem("self_name") || "";
    const newToggleState = forceStarting ? forceStarting : !toggleMic;
    setToggleMic(newToggleState);
    let qnaflows = ["flow_plan_v2", "flow_landing_page", "flow_post_session_qa"];
    if (qnaflows.includes(flowToStart)) {
      silent = true;
    }

    if (newToggleState) {
      setIsManuallyDisabled(false);
      setIsEnabled(true);

      // Always initialize voice (WebSocket) regardless of mic state
      initializeVoice();

      if (typeof onMicEnabledRef.current === "function") {
        onMicEnabledRef.current(true);
      }

      if (!silent) {
        setIsVisible(true);
      }
      const state = await getCurrentMicState();

      if (state === "granted") {
        // Mic permitted — resume listening
        VoiceService.resumeCompletely().catch(console.warn);
        setIsManuallyDisabled(false);
        if (!isListening) {
          VoiceService._callbacks.onListeningStart();
        }
        if (!forceStarting) {
          setTimeout(() => {
            startFlow(flowToStart);
            window.manuallyDisabledOnce = false;
          }, 500);
        }
        startFlow(flowToStart);
      } else {
        // Mic not yet permitted — start the flow anyway (TTS still works),
        // and let VoicePanel show the permission prompt when the user opens it.
        // startFlow(flowToStart);
        window.manuallyDisabledOnce = false;
        // Store flag so VoicePanel knows to ask for mic on open
        window._micPermissionPending = true;
      }
    }
    const state = await getCurrentMicState();
    if (state === "granted") {
      startFlow(flowToStart);
    } else {
      if (!ignoreMic) {
        MyraInteraction.showMicPermission();
      }
    }
    // if (isIntroARWithModeSelected) {
    //   startFlow(flowToStart);
    // }
  };

  const startFlowWithoutMic = async () => {
    const flowToStart = VoiceService._currentFlow || window.currentFlow;
    // setIsManuallyDisabled(false);
    setIsEnabled(true);

    // Always initialize voice (WebSocket) regardless of mic state
    initializeVoice();

    if (typeof onMicEnabledRef.current === "function") {
      onMicEnabledRef.current(true);
    }
    setIsVisible(true);
    startFlow(flowToStart);
  };
  const handleFabTap = () => {
    MyraInteraction.onFabTap();
  };

  const handlePickChat = () => {
    window.onkeydown = null;
    window.onkeyup = null;
    // VoiceService.stopAllVoiceActivity();
    window.initFromUserGesture();
    if (window.audioPlayer?.ctx?.state === "suspended") {
      console.log("[TTS_START] Resuming suspended AudioContext");
      window.audioPlayer.ctx
        .resume()
        .then(() => {
          console.log("[TTS_START] AudioContext resumed successfully");
        })
        .catch((err) => {
          console.error("[TTS_START] Failed to resume AudioContext:", err);
        });
    }
    const isIOS = /iPhone|iPad|iPod/.test(navigator.userAgent);
    if (isIOS && window.audioPlayer) {
      setTimeout(async () => {
        await window.audioPlayer.unlockAudioForChat();
      }, 5);
    }
    if (!VoiceService._flowReady) {
      const flowToStart = VoiceService._currentFlow || window.currentFlow;
      console.log("[MyraAgent] Pick chat: start flow without announcement", flowToStart);
      if(flowToStart !== "flow_exercise") {
      VoiceService.startFlowWithoutAnnouncement(flowToStart);
      } else {
        console.log("[MyraAgent] Pick chat: skip flow restart ");
      }
    }
    document.body.onkeydown = null;
    if (MyraInteraction.getCurrentScreen() === "intro_ar" && MyraInteraction.getIntroARState().showModeCard === true) {
      if (window.initAR) {
        window.initAR();
        MyraInteraction.openChat();
        window.mayraCode.startFlowWithoutMic();
      }
    }
    // VoiceService.announceBubbleMessage();
    let flowToStart = VoiceService._currentFlow || window.currentFlow;
    const isChatSelectedBefore = MyraInteraction.wasChatSelectedBefore();
    let msg;
    if (isChatSelectedBefore) {
      msg = "I'm here — what can I help with?";
    } else {
      if (window.AnalyticsService?.trackStep) {
        try {
          const existingData = JSON.parse(localStorage.getItem("assessmentData")) || {};
          const updatedData = {
            ...existingData,
            userUsesChat: true,
            session_last_update: new Date().toISOString(),
          };
          localStorage.setItem("assessmentData", JSON.stringify(updatedData));
          window.AnalyticsService.trackStep(updatedData);
        } catch (err) {
          console.error("Analytics camera decline error:", err);
        }
      }
      MyraInteraction.setChatSelectedBefore();
      msg = "Hi, I'm Myra — your recovery coach. I'm here to guide you through your assessment. Ask me anything, or use the buttons on screen.";
    }

    // VoiceService.announceBubbleMessage(msg);
    MyraInteraction.pickChat();
    MyraInteraction.onMyraMessage(msg);

    VoiceService._releaseMic();
    console.log("[MyraAgent] Pick chat, mic released");
  };

  const handlePickVoice = useCallback(async () => {
    const flowToStart = VoiceService._currentFlow || window.currentFlow;
    const userName = localStorage.getItem("self_name");
    console.log("[MyraAgent] Pick voice");
    window.initFromUserGesture();
    if (window.audioPlayer?.ctx?.state === "suspended") {
      await window.audioPlayer.ctx.resume();
    }

    // Open voice panel first
    MyraInteraction.pickVoice();
    MyraInteraction.openVoice();
    const isVoiceSelectedBefore = MyraInteraction.wasVoiceSelectedBefore();
    let msg;
    if (isVoiceSelectedBefore) {
      msg = "I'm listening — go ahead.";
    } else {
      if (window.AnalyticsService?.trackStep) {
        try {
          const existingData = JSON.parse(localStorage.getItem("assessmentData")) || {};
          const updatedData = {
            ...existingData,
            userUsesVoice: true,
            session_last_update: new Date().toISOString(),
          };
          localStorage.setItem("assessmentData", JSON.stringify(updatedData));
          window.AnalyticsService.trackStep(updatedData);
        } catch (err) {
          console.error("Analytics camera decline error:", err);
        }
      }
      MyraInteraction.setVoiceSelectedBefore();
      msg = "Hi, I'm Myra — your recovery coach. I'm here to guide you through your assessment. You can talk to me anytime, or just use the buttons on screen";
    }

    const granted = await requestMicrophonePermission({
      onGrant: async () => {
        //const isAndroid = /Android/i.test(navigator.userAgent);
        const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
        if (isMobile) {
          VoiceService.startFlowWithoutAnnouncement(flowToStart, userName, "");

          await new Promise((resolve) => {
            let numChecks = 0;
            let checkInt = setInterval(() => {
              if (VoiceService._ws?.readyState === WebSocket.OPEN && VoiceService._flowReady === true) {
                clearInterval(checkInt);
                resolve();
              }

              numChecks++;

              if (numChecks > 20) {
                clearInterval(checkInt);
                resolve();
              }
            }, 300);
          });

          await new Promise((resolve) => setTimeout(resolve, 300));
          setTimeout(() => {
            if (window.mayraCode?.doSay) {
              window.mayraCode.doSay(msg);
            } else if (VoiceService._ws?.readyState === WebSocket.OPEN) {
              VoiceService._speakAllowed = true;
              VoiceService._ws.send(JSON.stringify({ type: "say", text: msg }));
            }
            MyraInteraction.openVoice();
          }, 500);
        } else {
          setTimeout(() => {
            VoiceService.startFlowWithoutAnnouncement(flowToStart, userName, msg);
          }, 10);
          // MyraInteraction.openVoice();
        }
      },
      onDeny: () => {
        console.log("[MyraAgent] User denied mic - switching to chat");
        MyraInteraction.closeVoice();
        MyraInteraction.switchMode("chat");

        setTimeout(() => {
          VoiceService.startFlowWithoutAnnouncement(flowToStart);
          let msg = "No problem! We can chat instead. I'm here if you need anything — just type or use the buttons on screen.";
          MyraInteraction.pickChat();
          MyraInteraction.openChat();
          MyraInteraction.onMyraMessage(msg);
        }, 100);
      },
    });
  }, [requestMicrophonePermission]);
  const handleDismissBubble = () => {
    MyraInteraction.dismissBubble();
  };
  const handleCloseChat = () => {
    MyraInteraction.closeChat();
  };
  const handleCloseVoice = () => {
    MyraInteraction.closeVoice();
  };
  const handleSwitchMode = async (newMode) => {
    window.initFromUserGesture();
    if (window.audioPlayer?.ctx?.state === "suspended") {
      await window.audioPlayer.ctx.resume();
    }
    if (mode === "chat") {
      MyraInteraction.closeChat();
    }
    if (mode === "voice") {
      MyraInteraction.closeVoice();
    }
    let msg = "";
    if (mode === "voice" && newMode === "chat") {
      msg = "I'm here in chat now. What can I help with?";
    } else if (mode === "button" && newMode === "chat") {
      msg = "I'm here — what can I help with?";
      // VoiceService.announceBubbleMessage(msg);
    } else if (mode === "chat" && newMode === "voice") {
      msg = "I'm listening — go ahead.";
      // VoiceService.announceBubbleMessage(msg);
    } else if (mode === "button" && newMode === "voice") {
      msg = "I'm listening — go ahead.";
      // VoiceService.announceBubbleMessage(msg);
    }

    MyraInteraction.switchMode(newMode);
    if (newMode === "chat") {
      if (!VoiceService._flowReady) {
        const flowToStart = VoiceService._currentFlow || window.currentFlow;
        VoiceService.startFlowWithoutAnnouncement(flowToStart);
      }
      VoiceService.stopAllVoiceActivity();
      VoiceService._releaseMic();
      window.onkeydown = null;
      window.onkeyup = null;
      document.body.onkeydown = null;
      setTimeout(() => {
        MyraInteraction.pickChat();
        MyraInteraction.onMyraMessage(msg);
      }, 100);
    } else if (newMode === "voice") {
      const flowToStart = VoiceService._currentFlow || window.currentFlow;
      const userName = localStorage.getItem("self_name");
      window.initFromUserGesture();
      if (window.audioPlayer?.ctx?.state === "suspended") {
        await window.audioPlayer.ctx.resume();
      }
      if (!VoiceService._flowReady) {
        if (window.audioPlayer && window.audioPlayer.pcm) {
          // Stoping the any ongoing PCM playback
          if (typeof window.audioPlayer.ttsPcmAbort === "function") {
            window.audioPlayer.ttsPcmAbort();
          }
          // Force reset state
          window.audioPlayer.pcm.active = false;
          window.audioPlayer.pcm.queuedSamples = 0;
          window.audioPlayer.pcm.endReceived = false;
          window.audioPlayer.pcm.floatQueue = [];
          window.audioPlayer.pcm.floatQueueSamples = 0;
          window.audioPlayer.pcm.sources.clear();
        }
      }
      const granted = await requestMicrophonePermission({
        onGrant: async () => {
          if (!msg) {
            msg = "I'm listening — go ahead.";
          }
          MyraInteraction.openVoice();
          MyraInteraction.pickVoice();
          const isAndroid = /Android/i.test(navigator.userAgent);
          if (isAndroid) {
            VoiceService.startFlowWithoutAnnouncement(flowToStart, userName, "");
            await new Promise((resolve) => setTimeout(resolve, 300));
            setTimeout(() => {
              if (window.mayraCode?.doSay) {
                window.mayraCode.doSay(msg);
              } else if (VoiceService._ws?.readyState === WebSocket.OPEN) {
                VoiceService._speakAllowed = true;
                VoiceService._ws.send(JSON.stringify({ type: "say", text: msg }));
              }
            }, 1500);
          } else {
            VoiceService.startFlowWithoutAnnouncement(flowToStart, userName, msg);
          }
          const healthy = VoiceService._isActuallyListening();
          if (!healthy) {
            VoiceService._stopListening();
            VoiceService._startListening().catch((err) => {
              setTimeout(() => {
                VoiceService._startListening().catch((e) => console.error("[RECONNECT] Retry also failed:", e));
              }, 2000);
            });
          }
        },
        onDeny: () => {
          MyraInteraction.closeVoice();
          MyraInteraction.switchMode("chat");
          setTimeout(() => {
            MyraInteraction.openChat();
            MyraInteraction.pickChat();
            MyraInteraction.onMyraMessage("I'm here in chat now. What can I help with?");
          }, 100);
        },
      });
    } else {
      const isBtnSelectedBefore = MyraInteraction.wasbuttonSelectedBefore();
      if (isBtnSelectedBefore) {
        VoiceService._releaseMic();
      } else {
        if (window.AnalyticsService?.trackStep) {
          try {
            const existingData = JSON.parse(localStorage.getItem("assessmentData")) || {};
            const updatedData = {
              ...existingData,
              userUsesTap: true,
              session_last_update: new Date().toISOString(),
            };
            localStorage.setItem("assessmentData", JSON.stringify(updatedData));
            window.AnalyticsService.trackStep(updatedData);
          } catch (err) {
            console.error("Analytics camera decline error:", err);
          }
        }
        MyraInteraction.setButtonSelectedBefore();
        VoiceService._releaseMic();
      }
    }
  };

  const handleSendChatMessage = (text) => {
    let screenName = MyraInteraction.getCurrentScreen() || "";
    if (screenName === "intro_ar") {
      screenName = "test1_demo";
    }
    const rawData = localStorage.getItem("assessmentData");
    const assessmentData = rawData ? JSON.parse(rawData) : {};
    console.log("Payload---", screenName);

    const screenPayload = generatePayloadForScreen(screenName, assessmentData);
    MyraInteraction.sendChatMessage(text, screenPayload);
    // Note: chat backend not yet wired into GSA — message appears in UI only
  };

  const handleHomeScreenMyraClick = useCallback(
    async (silent = false) => {
      if (isVisible && isFlowStarted) return false;
      const granted = await requestMicrophonePermission({
        onGrant: async () => {
          // User granted permission - start full flow
          await startMyraFlow(silent);
          if (onMicEnabledRef.current) onMicEnabledRef.current(true);
        },
        onDeny: async (reason) => {
          // User denied - start flow without mic (TTS only)
          console.log("[MyraAgent] User denied mic - starting flow without mic");
          if (window.updateMyRAIsActive) window.updateMyRAIsActive(false);
          // await startMyraFlow(silent);
          VoiceService.startFlowWithoutAnnouncement("flow_landing_page");
        },
        onError: (error) => {
          console.error("[MyraAgent] Mic permission error:", error);
          // Still try to start flow without mic
          VoiceService.startFlowWithoutAnnouncement("flow_landing_page");
        },
      });
      return false;
    },
    [isVisible, isFlowStarted, isListening, startFlow, initializeVoice],
  );
  const ensureAudioPlaybackReady = async () => {
    if (!window.audioPlayer) {
      console.error("[MyraAgent] audioPlayer not found!");
      return false;
    }
    if (!window.audioPlayer.ctx) {
      window.audioPlayer.initFromUserGesture();
      await new Promise((resolve) => setTimeout(resolve, 100));
    }

    // Resume audio context if
    if (window.audioPlayer.ctx && window.audioPlayer.ctx.state === "suspended") {
      try {
        await window.audioPlayer.ctx.resume();
      } catch (error) {
        console.error("[MyraAgent] Failed to resume audio context:", error);
      }
    }
    return true;
  };

  const startMyraFlow = async (silent = false) => {
    try {
      if (window.updateMyRAIsActive) window.updateMyRAIsActive(true);
      setIsVisible(true);
      setIsEnabled(true);
      setIsManuallyDisabled(false);
      setIsFlowStarted(true);

      if (onMicEnabledRef.current) onMicEnabledRef.current(true);
      await ensureAudioPlaybackReady();
      initializeVoice();

      if (!isListening) {
        VoiceService._callbacks.onListeningStart();
      }

      let sessionId = window.trSessionId || localStorage.getItem("trSessionId");
      localStorage.setItem("trSessionId", sessionId);
      VoiceService.updateTouchPointandSessionId("landing", sessionId);

      setTimeout(() => {
        startFlow("flow_landing_page");
      }, 800);

      return true;
    } catch (error) {
      console.error("[MyraAgent] Error starting Myra flow:", error);
      return false;
    }
  };
  const requestMicrophoneAccess = () => {
    const userName = localStorage.getItem("self_name") || "";

    try {
      window.updateTextScreen({ USERNAME: userName, REQUEST_MICROPHONE_GRANTED: true, time: new Date().toISOString() });
      if (typeof window !== "undefined" && window.initFromUserGesture) {
        window.initFromUserGesture();
        console.log("Audio unlocked during mic permission flow");
      }

      if (typeof window !== "undefined" && window.unlockAllVideos) {
        window.unlockAllVideos();
      }

      initializeVoice();

      if (typeof navigator !== "undefined" && navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
        const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
        const isMacDesktop = /Macintosh|Mac OS X/.test(navigator.userAgent) && !isMobile;
        let constraints;
        if (isMacDesktop) {
          // MAC LAPTOP: Use default to avoid iPhone
          try {
            constraints = { audio: { deviceId: "default" } };
          } catch (error) {
            constraints = { audio: true };
          }
        } else if (isMobile) {
          // iPHONE/ANDROID: Use any available (their own mic)
          constraints = { audio: true };
        } else {
          // WINDOWS/OTHER: Use default
          constraints = { audio: { deviceId: "default" } };
        }
        navigator.mediaDevices
          .getUserMedia(constraints)
          .then((stream) => {
            if (window._voiceModePermissionCallback) {
              window._voiceModePermissionCallback(true);
              window._voiceModePermissionCallback = null;
            }
            if (window.updateMicModalCancel) {
              window.updateMicModalCancel(true);
            }
            const audioTrack = stream.getAudioTracks()[0];
            if (audioTrack) {
              window.updateTextScreen({
                SELECTED_MICROPHONE: audioTrack.label || "Default Device",
                DEVICE_ID: audioTrack.getSettings().deviceId || "default",
                time: new Date().toISOString(),
                USERNAME: userName,
              });
            }
            stream.getTracks().forEach((track) => track.stop());
            // if (onMicEnabledRef) {
            //   onMicEnabledRef.current();
            // }
            if (typeof onMicEnabledRef.current === "function") {
              onMicEnabledRef.current(true);
            }

            setIsVisible(true);
            setIsEnabled(true);
            setIsManuallyDisabled(false);
            // Update HomeScreen state if callback exists
            if (window.updateMyRAIsActive) {
              window.updateMyRAIsActive(true);
            }

            VoiceService.resumeCompletely();
            setIsManuallyDisabled(false);
            const flowToStart = VoiceService._currentFlow;
            if (!isListening) {
              window.debugForce = true;
              VoiceService._callbacks.onListeningStart(); // trigger hook path
            }

            window.manuallyDisabledOnce = false;

            if (flowToStart) {
              setTimeout(() => {
                startFlow(flowToStart);
              }, 500);
            }
          })
          .catch((err) => {
            if (window._voiceModePermissionCallback) {
              window._voiceModePermissionCallback(false);
              window._voiceModePermissionCallback = null;
            }
            if (err.name === "NotAllowedError" || err.name === "PermissionDeniedError") {
              MyraInteraction.onMicPermissionDenied();
              console.log("User mic is denied by himself, he needs to enable it in system settings");
              document.dispatchEvent(new CustomEvent("micPermissionDenied"));
              console.error("Microphone access denied - user needs to enable in browser/system settings:", {
                errorName: err.name,
                errorMessage: err.message,
                browser: navigator.userAgent,
                timestamp: new Date().toISOString(),
              });
            } else {
              console.error("Microphone access failed with error:", err);
            }

            if (window.updateMicModalCancel) {
              window.updateMicModalCancel();
            }
            console.log("Microphone access denied:", err);
            if (window.updateMyRAIsActive) {
              window.updateMyRAIsActive(false);
            }
          });
      } else {
        if (window.updateMicModalCancel) {
          window.updateMicModalCancel();
        }
        window.updateTextScreen({ USERNAME: userName, REQUEST_MICROPHONE_DENIED: true, time: new Date().toISOString() });
        if (window.updateMyRAIsActive) {
          window.updateMyRAIsActive(false);
        }
      }
    } catch (error) {
      console.log("User mic is denied by himself, he needs to enable it in system settings");
      console.error("Exception in requestMicrophoneAccess:", error);
      // document.dispatchEvent(new CustomEvent("micPermissionDenied"));
      if (window.updateMicModalCancel) {
        window.updateMicModalCancel();
      }
      window.updateTextScreen({ USERNAME: userName, REQUEST_MICROPHONE_DENIED: true, time: new Date().toISOString() });
      console.log("Microphone access denied:", error);
      if (window.updateMyRAIsActive) {
        window.updateMyRAIsActive(false);
      }
    }
  };

  const onMicEnabledRef = useRef(null);
  const setOnMicEnabled = useCallback((cb) => {
    onMicEnabledRef.current = typeof cb === "function" ? cb : null;
  }, []);
  // eslint-disable-next-line
  const forceStop = useCallback(() => {
    VoiceService._callbacks.onAgentSpeechEndCustom = () => {};
    VoiceService._stopListening();
    VoiceService.forceStop();
    VoiceService.stopAllVoiceActivity();
    setTimeout(() => {
      VoiceService._stopListening();
    }, 500);
  }, []);

  const doSay = useCallback(async (text, doCallback, speed = 1.0) => {
    try {
      const userName = window.localStorage.getItem("self_name") || "";
      // Clamp speed between 0.7 and 1.2 (backend constraint)
      const validSpeed = Math.min(1.2, Math.max(0.7, typeof speed === "number" ? speed : 1.0));

      console.log("Saying", text, userName);
      const isIOS = /iPhone|iPad|iPod/.test(navigator.userAgent);
      if (isIOS && window.audioPlayer) {
        await window.audioPlayer.unlockAudioForChat();
      }

      VoiceService._pendingDoSayCallback = doCallback || null;
      VoiceService._speakAllowed = true;
      window.initFromUserGesture();
      if (window.audioPlayer?.ctx?.state === "suspended") {
        try {
          await window.audioPlayer.ctx.resume();
          console.log("[CHAT] AudioContext resumed successfully");
        } catch (err) {
          window.initFromUserGesture();
          console.error("[TTS_START] Failed to resume AudioContext:", err);
        }
      }

      if (VoiceService._ws && VoiceService._ws.readyState === WebSocket.OPEN) {
        VoiceService._speakAllowed = true;
        VoiceService._ws.send(JSON.stringify({ type: "say", text: text, name: userName, speed: validSpeed }));

        VoiceService._callbacks.onAgentSpeechEndCustom = () => {
          console.log("Called back");

          // if (doCallback) {
          //   doCallback();
          // }

          VoiceService._callbacks.onAgentSpeechEndCustom = () => {};
        };

        console.log("Sent speech command to backend");
      } else {
        console.warn("WebSocket not connected - cannot send speech command");
        const flowToStart = VoiceService._currentFlow || window.currentFlow;
        const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
        if (isMobile) {
          VoiceService._speakAllowed = true;
          VoiceService.startFlowWithoutAnnouncement(flowToStart, userName, "");

          await new Promise((resolve) => {
            let numChecks = 0;
            let checkInt = setInterval(() => {
              if (VoiceService._ws?.readyState === WebSocket.OPEN && VoiceService._flowReady === true) {
                clearInterval(checkInt);
                resolve();
              }

              numChecks++;

              if (numChecks > 20) {
                clearInterval(checkInt);
                resolve();
              }
            }, 300);
          });

          await new Promise((resolve) => setTimeout(resolve, 300));
          setTimeout(() => {
            if (VoiceService._ws?.readyState === WebSocket.OPEN) {
              VoiceService._speakAllowed = true;
              VoiceService._ws.send(JSON.stringify({ type: "say", text: text, speed: validSpeed }));
            }
          }, 500);
          VoiceService._callbacks.onAgentSpeechEndCustom = () => {
            console.log("Called back from flow announcement");
            // if (doCallback) {
            //   doCallback();
            // }
            VoiceService._callbacks.onAgentSpeechEndCustom = () => {};
          };
        } else {
          VoiceService._speakAllowed = true;
          VoiceService.startFlowWithoutAnnouncement(flowToStart, userName, text);
          VoiceService._callbacks.onAgentSpeechEndCustom = () => {
            console.log("Called back from flow announcement");
            // if (doCallback) {
            //   doCallback();
            // }
            VoiceService._callbacks.onAgentSpeechEndCustom = () => {};
          };
        }
      }
    } catch (error) {
      console.error("Error sending speech command:", error);
      if (doCallback) {
        setTimeout(doCallback, 100);
      }
      VoiceService._pendingDoSayCallback = null;
    }
  }, []);

  const doSayPreload = useCallback((text) => {
    try {
      const userName = window.localStorage.getItem("self_name") || "";
      console.log("Saying", text, userName);

      if (VoiceService._ws && VoiceService._ws.readyState === WebSocket.OPEN) {
        VoiceService._ws.send(JSON.stringify({ type: "say_silent", text: text, name: userName }));
        console.log("Sent speech command to backend");
      } else {
        console.warn("WebSocket not connected - cannot send speech command");
      }
    } catch (error) {
      console.error("Error sending speech command:", error);
    }
  }, []);

  const disableCallback = useCallback(() => {
    try {
      VoiceService._callbacks.onAgentSpeechEndCustom = () => {};
    } catch (error) {
      console.error("Error disabling callback:", error);
    }
  }, []);

  const setupGlobalVirtualListener = useCallback(() => {
    window.startFlowFlutter = (flow, callbackArray, callbackSpeakOver) => {
      VoiceService._currentFlow = flow;

      if (isManuallyDisabledRef.current) {
        console.log("Voice agent is manually disabled, not starting Flutter flow:", flow);
        return;
      }
      // Start Myra flow speaking
      window.mayraCode.startFlow(flow, () => {
        // Call function once speak is completed
        console.log("Called myraCallbackFlutter");
        if (window.myraCallbackFlutter) {
          window.myraCallbackFlutter(callbackSpeakOver);
        }
      });

      // Listen for any commands that were sent and forward to myraResponse function
      window.currentCommandsAudio = {};
      for (let oneItem of callbackArray) {
        window.currentCommandsAudio[oneItem] = (val) => {
          if (window.myraResponse) {
            window.myraResponse(val);
          }
        };
      }
    };

    window.startListenMyra = (listeningFor) => {
      // Check if manually disabled before starting listening
      if (isManuallyDisabledRef.current) {
        console.log("Voice agent is manually disabled, not starting listening for:", listeningFor);
        return;
      }
      console.log("Recevied 1", listeningFor);

      let listenObject = [];
      if (typeof listeningFor == "string" && listeningFor.indexOf("}") > 0) {
        try {
          listenObject = JSON.parse(listeningFor);
          listeningFor = listenObject[0];
        } catch (e) {
          console.error(e);
        }
      }

      console.log("Recevied 2", listenObject);

      if (listeningFor === "flow_demo_video") {
        window.stopAudio();
        window.mayraCode.disableCallback();
        window.mayraCode.setIsVisible(true);
        window.mayraCode.startFlow("flow_demo_video");
        VoiceService._currentFlow = "flow_demo_video";
        window.currentCommandsAudio = {
          SKIP_VIDEO: () => {
            if (window.virtualDemoPlay) {
              window.virtualDemoPlay.pause();
            }
            window.mayraCode.doSay("Got it! Skipping the video.", () => {
              setTimeout(() => {
                if (window.skipDemoVideoMyra) {
                  window.skipDemoVideoMyra();
                }
              }, 2000);
            });
          },

          REPLAY_VIDEO: () => {
            if (window.virtualDemoPlay) {
              window.virtualDemoPlay.pause();
              window.mayraCode.doSay("Sure! I'll replay the video for you.", () => {
                window.virtualDemoPlay.seek(0);
                window.virtualDemoPlay.play();
              });
            }
          },
          PAUSE_VIDEO: () => {
            if (window.virtualDemoPlay) {
              window.virtualDemoPlay.pause();
              window.mayraCode.doSay("Sure! I’ll pause the video for you. When you’re ready to continue, just say Myra, resume video.", () => {});
            }
          },
          ANSWER_MidJourneyFlow_QUESTION: () => {
            if (window.virtualDemoPlay) {
              window.virtualDemoPlay.pause();
            }
          },
          RESUME_VIDEO: () => {
            if (window.virtualDemoPlay) {
              if (document.querySelector("#player_ondemand video")) {
                if (document.querySelector("#player_ondemand video").paused) {
                  window.mayraCode.doSay("Sure! I'll re-zume the video for you.", () => {
                    window.virtualDemoPlay.play();
                  });
                }
              }
            }
          },
          INVALID_COMMAND: () => {
            if (window.virtualDemoPlay) {
              window.virtualDemoPlay.pause();
              window.mayraCode.doSay("I didn't catch that one. Here's what I can help with: Skip the video, Replay the video, pauze the video, and Expand the video", () => {
                setTimeout(() => {
                  window.virtualDemoPlay.play();
                }, 400);
              });
            }
          },
          VALID_COMMAND: () => {
            if (window.virtualDemoPlay) {
              window.virtualDemoPlay.pause();
              window.mayraCode.doSay("On this screen I can help you with the following : Skip the video, Replay the video, pauze the video, and Expand the video", () => {
                setTimeout(() => {
                  window.virtualDemoPlay.play();
                }, 400);
              });
            }
          },
        };
      } else if (listeningFor === "notvisible") {
        window.mayraCode.disableCallback();
        window.mayraCode.startFlow("notvisible");
        window.currentCommandsAudio = {
          START_HELP: () => {
            if (window.myraResponse) {
              window.myraResponse("START_HELP");
            }
          },
          START_PAUSE: () => {
            if (window.myraResponse) {
              window.myraResponse("START_PAUSE");
            }
          },
        };
      } else if (listeningFor === "flow_exercise") {
        if (window.movementTestPayload) {
          window.mayraForwardCode = {
            midjourneyData: window.movementTestPayload,
          };
        }
        window.mayraCode.setIsVisible(true);
        window.mayraCode.disableCallback();
        window.mayraCode.startFlow("flow_exercise");
        window.currentCommandsAudio = {
          PAUSE_EXERCISE: (val) => {
            if (window.myraResponse) {
              window.myraResponse("PAUSE_EXERCISE");
            }
          },
          RESTART: (val) => {
            if (window.myraResponse) {
              window.myraResponse("RESTART");
            }
          },
          READY: (val) => {
            if (window.myraResponse) {
              window.myraResponse("READY");
            }
          },
          SAY_THAT_AGAIN: (val) => {
            if (window.myraResponse) {
              window.myraResponse("SAY_THAT_AGAIN");
            }
          },
          RESTART_EXERCISE: (val) => {
            if (window.myraResponse) {
              window.myraResponse("RESTART_EXERCISE");
            }
          },
          RESUME_EXERCISE: (val) => {
            if (window.myraResponse) {
              window.myraResponse("RESUME_EXERCISE");
            }
          },
          SKIP_EXERCISE: (val) => {
            if (window.myraResponse) {
              window.myraResponse("SKIP_EXERCISE");
            }
          },
          SELECT_ANSWER: (val) => {
            if (window.myraResponse) {
              window.myraResponse(val);
            }
          },
          CONFIRM_START_POSITION: (val) => {
            if (window.myraResponse) {
              window.myraResponse("CONFIRM_START_POSITION");
            }
          },
          SESSION_CHOICE: (val) => {
            if (window.myraResponse) {
              window.myraResponse(val);
            }
          },
        };
      } else if (listeningFor === "endSessionFlow") {
        window.mayraCode.disableCallback();
        window.mayraCode.startFlow("endSessionFlow");
        window.currentCommandsAudio = {
          SELECT_ANSWER: (val) => {
            if (window.myraResponse) {
              window.myraResponse(val);
            }
          },
        };
      } else if (listeningFor === "skippedExerciseFlow") {
        window.mayraCode.disableCallback();
        window.mayraForwardCode = listenObject[1] || {};
        window.mayraCode.startFlow("skippedExerciseFlow");
        window.currentCommandsAudio = {
          SELECT_ANSWER: (val) => {
            if (window.myraResponse) {
              window.myraResponse(val);
            }
          },
          SESSION_CHOICE: (val) => {
            if (window.myraResponse) {
              window.myraResponse(val);
            }
          },
          SELECTED_RPE: (val) => {
            if (window.myraResponse) {
              window.myraResponse(val);
            }
          },
          SELECT_RPE: (val) => {
            if (window.myraResponse) {
              window.myraResponse(val);
            }
          },

          SELECT_LATER: (val) => {
            if (window.myraResponse) {
              window.myraResponse("LATER");
            }
          },
          SELECT_DONT_LIKE: (val) => {
            if (window.myraResponse) {
              window.myraResponse("DONT_LIKE");
            }
          },
          SELECT_HARD: (val) => {
            if (window.myraResponse) {
              window.myraResponse("HARD");
            }
          },
          SESSION_END: (val) => {
            if (window.myraResponse) {
              window.myraResponse("END");
            }
          },
          SESSION_NEXT: (val) => {
            if (window.myraResponse) {
              window.myraResponse("NEXT");
            }
          },
        };
      } else if (listeningFor === "ExerciseCompletedDoneBefore") {
        window.mayraCode.disableCallback();
        window.mayraCode.startFlow("ExerciseCompletedDoneBefore");
        window.currentCommandsAudio = {
          SELECT_ANSWER: (val) => {
            if (window.myraResponse) {
              window.myraResponse(val);
            }
          },
          SESSION_CHOICE: (val) => {
            if (window.myraResponse) {
              window.myraResponse(val);
            }
          },
          EXERCISE_COMPLETED: (val) => {
            if (window.myraResponse) {
              window.myraResponse(val);
            }
          },
          SELECT_COMPARISON: (val) => {
            if (window.myraResponse) {
              window.myraResponse(val);
            }
          },
          SELECTED_RPE: (val) => {
            if (window.myraResponse) {
              window.myraResponse(val);
            }
          },
          SELECT_RPE: (val) => {
            if (window.myraResponse) {
              window.myraResponse(val);
            }
          },
          SELECT_SYMPTOM: (val) => {
            if (window.myraResponse) {
              window.myraResponse(val);
            }
          },
        };
      } else if (listeningFor === "ExerciseCompletedFirstTimeFlow") {
        window.mayraCode.disableCallback();
        window.mayraForwardCode = listenObject[1] || {};
        window.mayraCode.startFlow("ExerciseCompletedFirstTimeFlow");
        window.currentCommandsAudio = {
          SELECT_ANSWER: (val) => {
            if (window.myraResponse) {
              window.myraResponse(val);
            }
          },
          SESSION_CHOICE: (val) => {
            if (window.myraResponse) {
              window.myraResponse(val);
            }
          },
          EXERCISE_COMPLETED: (val) => {
            if (window.myraResponse) {
              window.myraResponse(val);
            }
          },
          SELECT_COMPARISON: (val) => {
            if (window.myraResponse) {
              window.myraResponse(val);
            }
          },
          SELECTED_RPE: (val) => {
            if (window.myraResponse) {
              window.myraResponse(val);
            }
          },
          SELECT_RPE: (val) => {
            if (window.myraResponse) {
              window.myraResponse(val);
            }
          },
          SELECT_SYMPTOM: (val) => {
            if (window.myraResponse) {
              window.myraResponse(val);
            }
          },
        };
      } else if (listeningFor === "flow_partial_session_done" || listeningFor === "flow_after_exercise" || listeningFor === "flow_symptom" || listeningFor === "flow_rpe") {
        window.mayraCode.disableCallback();
        window.mayraForwardCode = listenObject[1] || {};

        if (listeningFor === "flow_rpe") {
          window.mayraCode.startFlow("flow_rpe", "rpe_exercise");
        }
        if (listeningFor === "flow_symptom") {
          window.mayraCode.startFlow("flow_symptom", "symptom_exercise");
        }
        if (listeningFor === "flow_after_exercise") {
          window.mayraCode.startFlow("flow_after_exercise", "after_exercise");
        }
        if (listeningFor === "flow_partial_session_done") {
          window.mayraCode.startFlow("flow_partial_session_done", "after_exercise_partial");
        }

        window.currentCommandsAudio = {
          SELECT_ANSWER: (val) => {
            if (window.myraResponse) {
              window.myraResponse(val);
            }
          },
          SESSION_CHOICE: (val) => {
            if (window.myraResponse) {
              window.myraResponse(val);
            }
          },
          EXERCISE_COMPLETED: (val) => {
            if (window.myraResponse) {
              window.myraResponse(val);
            }
          },
          SELECT_COMPARISON: (val) => {
            if (window.myraResponse) {
              window.myraResponse(val);
            }
          },
          SELECTED_RPE: (val) => {
            if (window.myraResponse) {
              window.myraResponse(val);
            }
          },
          SELECT_RPE: (val) => {
            if (window.myraResponse) {
              window.myraResponse(val);
            }
          },
          SELECT_SYMPTOM: (val) => {
            if (window.myraResponse) {
              window.myraResponse(val);
            }
          },
          SELECT_LATER: (val) => {
            if (window.myraResponse) {
              window.myraResponse("LATER");
            }
          },
          SELECT_DONT_LIKE: (val) => {
            if (window.myraResponse) {
              window.myraResponse("DONT_LIKE");
            }
          },
          SELECT_HARD: (val) => {
            if (window.myraResponse) {
              window.myraResponse("HARD");
            }
          },
          SESSION_END: (val) => {
            if (window.myraResponse) {
              window.myraResponse("END");
            }
          },
          SESSION_NEXT: (val) => {
            if (window.myraResponse) {
              window.myraResponse("NEXT");
            }
          },
          SESSION_LATER: (val) => {
            if (window.myraResponse) {
              window.myraResponse("LATER");
            }
          },
          SESSION_DONT_LIKE: (val) => {
            if (window.myraResponse) {
              window.myraResponse("DONT_LIKE");
            }
          },
          SESSION_HARD: (val) => {
            if (window.myraResponse) {
              window.myraResponse("HARD");
            }
          },
          SESSION_DONE: (val) => {
            if (window.myraResponse) {
              window.myraResponse("DONE");
            }
          },
        };
      } else if (listeningFor === "flow_post_session_qa") {
        window.mayraCode.disableCallback();
        window.mayraCode.sendPostQA(listenObject[1] || {});
        window.mayraCode.startFlow("flow_post_session_qa");
        window.currentCommandsAudio = {};
      } else if (listeningFor === "start_silent") {
        window.mayraCode.disableCallback();
        window.mayraCode.startFlow("start_silent");
        window.currentCommandsAudio = {};
      }
    };
  }, [isManuallyDisabledRef]);
  const handleIntroARModeSelect = (selectedMode) => {
    setIntroARSelectedMode(selectedMode);
  };

  // confirmIntroARMode is called from the GSA screen's Continue button
  // exposed via window.mayraCode.confirmIntroARMode
  const confirmIntroARMode = useCallback(() => {
    MyraInteraction.confirmIntroARMode(introARSelectedMode);
  }, [introARSelectedMode]);

  const api = useMemo(
    () => ({
      startFlow,
      initializeVoice,
      setIsVisible,
      setOnMicEnabled,
      doSay,
      doSayPreload,
      handleMicClick,
      startFlowWithoutMic,
      handleHomeScreenMyraClick,
      forceStop,
      isEnabled,
      isVisible,
      isFlowStarted,
      setIsFlowStarted,
      disableCallback,
      setupGlobalVirtualListener,
      sendPostQA,
      confirmIntroARMode,
      handlePickVoice,
      handlePickChat,
      requestMicrophonePermission,
      checkMicPermission: getCurrentMicState,
      getIntroARState: () => MyraInteraction.getIntroARState(),
      introARSelectedMode,
      onIntroARModeSelect: handleIntroARModeSelect,
      setHelpState: (helpDataArray) => {
        return VoiceService.setHelpState(helpDataArray);
      },
      getState: () => ({
        isAgentSpeaking,
        isListening,
        isManuallyDisabled,
        isManuallyDisabledRef,
      }),
    }),
    [startFlow, initializeVoice, isAgentSpeaking, isListening, setIsVisible, setOnMicEnabled, doSay, doSayPreload, handleMicClick, forceStop, isEnabled, isVisible, disableCallback, setupGlobalVirtualListener, sendPostQA, isManuallyDisabled, isFlowStarted, isManuallyDisabledRef, confirmIntroARMode, introARSelectedMode],
  );

  // Hand the API to parent when available; clear on unmount
  useEffect(() => {
    window.mayraCode = api;
    window.startFlow = api.startFlow;
    window.mayraForceStop = () => {
      window.mayraCode.forceStop();
      setIsVisible(false);
      setIsEnabled(false);
    };

    window.doSay = api.doSay;
    window.doSayPreload = api.doSayPreload;
    window.setHelpState = api.setHelpState;
    window.handleHomeScreenMyraClick = api.handleHomeScreenMyraClick;
    window.requestMicrophonePermission = api.requestMicrophonePermission;
    window.checkMicPermission = api.checkMicPermission;

    window.stopMyraCommands = () => {
      window.mayraCode.setOnMicEnabled(null);
      window.currentCommandsAudio = {};
      window.mayraCode.disableCallback();
      window.mayraCode.startFlow("flow_silent");
    };

    window.getMyraSpeaking = () => {
      return isAgentSpeaking ? "yes" : "no";
    };

    window.flutterOpenChatPanel = () => {
    // if (MyraInteraction.getMode() !== "chat") {
    //   console.log("[Flutter→React] flutterOpenChatPanel skipped — mode is not chat");
    //   return false;
    // }

    if (!MyraInteraction.isChatOpen()) {
      console.log("[Flutter→React] flutterOpenChatPanel — opening chat panel");
      MyraInteraction.openChat();
    } else {
      console.log("[Flutter→React] flutterOpenChatPanel — chat already open");
    }

    return true;
  };

  window.flutterCloseChatPanel = () => {
    if (MyraInteraction.isChatOpen()) {
      console.log("[Flutter→React] flutterCloseChatPanel — closing chat panel");
      MyraInteraction.closeChat();
    } else {
      console.log("[Flutter→React] flutterCloseChatPanel — chat not open, skip");
    }

    return true;
  };

    return () => props.onAgentApi?.(null);
  }, [api]);

  return (
    <div>
      <VoiceAgent isAgentSpeaking={isAgentSpeaking} isListening={isListening} onMicClick={handleMicClick} isVisible={isVisible} isVoiceActive={isVoiceActive} connectionStatus={connectionStatus} mode={mode} isFabExpanded={isFabExpanded} isBubbleVisible={isBubbleVisible} isChatOpen={isChatOpen} isVoiceOpen={isVoiceOpen} chatMessages={chatMessages} introARState={MyraInteraction.getIntroARState()} onFabTap={handleFabTap} onPickChat={handlePickChat} onPickVoice={handlePickVoice} onDismissBubble={handleDismissBubble} onCloseChat={handleCloseChat} onCloseVoice={handleCloseVoice} onSendChatMessage={handleSendChatMessage} onSwitchMode={handleSwitchMode} isChatLoading={isChatLoading} onMicRequest={requestMicrophoneAccess} />
    </div>
  );
}

export default MyraAgent;
